import { render, staticRenderFns } from "./MaterialCardList.vue?vue&type=template&id=74b1e9fc&scoped=true"
import script from "./MaterialCardList.vue?vue&type=script&lang=js"
export * from "./MaterialCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1e9fc",
  null
  
)

export default component.exports